// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__lmQlD","buttons":"PendingPaymentAlert_buttons__3olWV"};